import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import Nav from "./Nav";
import Logo from "../../assets/logo.png";

function Navbar() {
  const [sidebar, setSidebar] = useState(false);

  const toggleSidebar = () => setSidebar((prev) => !prev);

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="flex items-center justify-between text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Open menu"
      >
        {/* Menu Icon */}
        <FaBars className="text-2xl" />
        {/* Logo */}
        <img
          src={Logo}
          alt="EBS Transliteration"
          className="h-9 md:h-10 w-auto"
        />

      </button>

      <Nav sidebar={sidebar} toggleSidebar={toggleSidebar} />
    </>
  );
}

export default Navbar;
